import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-custom-stock-protection-instructions',
    templateUrl: './custom-stock-protection-instructions.component.html',
    styleUrls: ['./custom-stock-protection-instructions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomStockProtectionInstructionsComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
